
export const MODAL_CONSTANTS = {
  TITLE: "Información",
  BODY: "El <b>user</b> ya se encuentra creado, desea actualizar la contraseña ?",
}